if (!customElements.get('adev-main-collection')) {
    customElements.define('adev-main-collection', class adevMainCollection extends HTMLElement {
        constructor() {
            super();

            this.filterForm = this.querySelector('[data-adev-products-filter="form"]');

            this.openFilterButton = this.querySelector('[data-adev-main-collection="open-filter"]');
        }

        loading(state = true) {
            if (state) {
                this.classList.add('is--loading');
            } else {
                this.classList.remove('is--loading');
            }
        }

        onFilterSubmit(event) {
            event.preventDefault();

            this.loading(true);
            
            const url = new URL(window.location);
            const params = new URLSearchParams(new FormData(this.filterForm));
                
            url.search = params.toString();
            history.pushState({}, '', url);

            
            fetch(url, {
                method: 'GET',
            })
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const mainCollectionEl = doc.querySelector('adev-main-collection');
                if (mainCollectionEl) {
                    this.replaceWith(mainCollectionEl);
                }
            })
            .finally(() => {
                this.loading(false);
            });
        }

        onOpenFilterButtonClick() {
            document.dispatchEvent(new CustomEvent('adev:open:collection-filters-drawer'));
        }

        connectedCallback() {
            this.filterForm.addEventListener('change', this.onFilterSubmit.bind(this));
            this.openFilterButton.addEventListener('click', this.onOpenFilterButtonClick.bind(this));
        }

        disconnectedCallback() {
            this.filterForm.removeEventListener('change', this.onFilterSubmit.bind(this));
            this.openFilterButton.removeEventListener('click', this.onOpenFilterButtonClick.bind(this));
        }

    });
}

if (!customElements.get('adev-price-range-input')) {
    customElements.define('adev-price-range-input', class adevPriceRangeInput extends HTMLElement {
        constructor() {
            super();

            this.inputEl = this.querySelector('input');
            this.applyEl = this.querySelector('[data-adev-price-range-input="apply-price-range"]');
            this.clearEl = this.querySelector('[data-adev-price-range-input="clear-price-range"]');

            if (this.inputEl.value !== '') {
                this.classList.add('is--not-empty');
            }
        }

        onInputChange(event) {
            const value = this.inputEl.value;
            const sanitizedValue = value.replace(/[^0-9.]/g, '');
        
            if (sanitizedValue !== value) {
                this.inputEl.value = sanitizedValue;
            }
        
            const min = this.inputEl.getAttribute('min');
            const max = this.inputEl.getAttribute('max');
        
            if (min !== null && parseFloat(this.inputEl.value) < parseFloat(min)) {
                this.inputEl.value = min;
            }
        
            if (max !== null && parseFloat(this.inputEl.value) > parseFloat(max)) {
                this.inputEl.value = max;
            }
        
            if (this.inputEl.value === '') {
                this.classList.remove('is--not-empty');
                this.classList.remove('is--changed');
                return;
            }
        
            this.classList.add('is--changed');
        }

        onApplyClick() {
            this.classList.remove('is--changed');
            this.inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        onClearClick() {
            this.inputEl.value = '';
            this.classList.remove('is--not-empty');
            this.classList.remove('is--changed');
            this.inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        connectedCallback() {
            this.inputEl.addEventListener('input', this.onInputChange.bind(this));
            this.applyEl.addEventListener('click', this.onApplyClick.bind(this));
            this.clearEl.addEventListener('click', this.onClearClick.bind(this));
        }

        disconnectedCallback() {
            this.inputEl.removeEventListener('input', this.onInputChange.bind(this));
            this.applyEl.removeEventListener('click', this.onApplyClick.bind(this));
            this.clearEl.removeEventListener('click', this.onClearClick.bind(this));
        }

    });
}

if (!customElements.get('adev-cf-drawer')) {
    customElements.define('adev-cf-drawer', class adevCollectionFilterDrawer extends HTMLElement {
        constructor() {
            super();

            this.filterForm = this.querySelector('[data-adev-products-filter="form"]');
            this.closeEl = this.querySelector('[data-adev-cf-drawer="close"]');

            this.applyEl = this.querySelector('[data-adev-cf-drawer="apply"]');
            this.applyEl.disabled = true;

            document.addEventListener('adev:overlay:closed', () => {
                this.close();
            });

            document.addEventListener('adev:open:collection-filters-drawer', () => {
                this.open();
            });
        }

        open() {
            this.classList.add('is--opened');
            document.documentElement.classList.add('is--overlay-on');
        }

        close() {
            this.classList.remove('is--opened');
            document.documentElement.classList.remove('is--overlay-on');
        }

        submitFilter(event) {
            event.preventDefault();
            
            const mainCollectionEl = document.querySelector('adev-main-collection');
            const url = new URL(window.location);
            const params = new URLSearchParams(new FormData(this.filterForm));
                
            url.search = params.toString();
            history.pushState({}, '', url);

            mainCollectionEl.loading(true);

            this.close();
            this.applyEl.disabled = true;
            
            fetch(url, {
                method: 'GET',
            })
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const docMainCollectionEl = doc.querySelector('adev-main-collection');
                mainCollectionEl.replaceWith(docMainCollectionEl);
                
                mainCollectionEl.loading(false);
            })
            .finally(() => {
                mainCollectionEl.loading(false);
            });
        }

        onChangeFilterForm() {
            this.applyEl.disabled = false;
        }

        connectedCallback() {
            this.filterForm.addEventListener('change', this.onChangeFilterForm.bind(this));
            this.closeEl.addEventListener('click', this.close.bind(this));
            this.applyEl.addEventListener('click', this.submitFilter.bind(this));
        }

        disconnectedCallback() {
            this.filterForm.removeEventListener('change', this.onChangeFilterForm.bind(this));
            this.closeEl.removeEventListener('click', this.close.bind(this));
            this.applyEl.removeEventListener('click', this.submitFilter.bind(this));
        }

    });
}